import XInput from '../../../../components/common/XInput';
import CaseFileUpload from '../../../../components/common/CaseFileUpload';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import useEconomicDamageForm from '../../../../hooks/useEconomicDamageForm';
import CurrencyInput from '../../../../components/common/CurrencyInput';
import { formTitleClasses, formBackgroundClasses, formItemPdClasses } from '../../../../components/common/formClasses';
import { TOUR_TARGETS } from '../../../../constants/tourTargets';

const wrapperClasses = 'p-0!';

const sectionTitleClasses = `${formTitleClasses} mb-6 text-2xl`;

const subsectionTitleClasses = `${formTitleClasses} mb-6`;

const futureMedicalHeaderRowClasses = 'flex items-center justify-between';

const futureMedicalTitleClasses = `${formTitleClasses} mb-6`;

const futureMedicalRowClasses = 'row mt-1! mb-4!';

const EconomicDamageAnalysisForm = () => {
    const {
        economicDamagePaths,
        getFieldProps,
        lossOfEarningFiles,
        futureMedicalExpenseFiles,
        isMedicalLoading,
        isEarningLoading,
        removeEconomicDamageFile,
        handleEconomicDamageUpload,
    } = useEconomicDamageForm();

    return (
        <div className={wrapperClasses} onKeyDown={(e) => handleEnterKeyPress(e)}>
            <div className={`${formBackgroundClasses} ${formItemPdClasses}`} data-tour={TOUR_TARGETS.ECONOMIC_DAMAGES}>
                <h3 className={sectionTitleClasses}>Future Economic Damages</h3>
                <h3 className={subsectionTitleClasses}>Loss of Earnings</h3>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <XInput
                                label="Work Hours Missed"
                                placeholder="Write hours..."
                                type="number"
                                {...getFieldProps(economicDamagePaths.workHoursMissed)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <CurrencyInput
                                label="Hourly Income Rate"
                                placeholder="Enter here"
                                {...getFieldProps(economicDamagePaths.hourlyIncomeRate)}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <XInput
                                label="Enter Type of Work"
                                placeholder="Enter here"
                                {...getFieldProps(economicDamagePaths.typeOfWork)}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-4!">
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <div className="form-group">
                                <CaseFileUpload
                                    label='Loss of Earnings'
                                    onFileSelect={(files) => handleEconomicDamageUpload({ fieldType: 'lossOfEarning', files })}
                                    files={lossOfEarningFiles}
                                    onRemove={(fileToRemove) => removeEconomicDamageFile({ fieldType: 'lossOfEarning', fileToRemove })}
                                    isLoading={isEarningLoading}
                                    multiple={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={futureMedicalHeaderRowClasses}>
                    <h2 className={futureMedicalTitleClasses}>Future Medical Expenses</h2>
                </div>
                <div className={futureMedicalRowClasses}>
                    <div className="col-md-12">
                        <div className="col-md-12">
                            <div className="form-group">
                                <CaseFileUpload
                                    label='Future Medical Expenses'
                                    onFileSelect={(files) => handleEconomicDamageUpload({ fieldType: 'futureMedicalExpense', files })}
                                    files={futureMedicalExpenseFiles}
                                    onRemove={(fileToRemove) => removeEconomicDamageFile({ fieldType: 'futureMedicalExpense', fileToRemove })}
                                    isLoading={isMedicalLoading}
                                    multiple={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EconomicDamageAnalysisForm;
